import React from 'react';
import SectionHeading from '../shared/SectionHeading';
import serviceAreas from '../../data/serviceAreas';
import mountainImage from '../../assets/service-area-optimized.jpg';

const ServiceAreaSection = () => (
  <section className="section">
    <div className="container service-area-layout">
      <div>
        <SectionHeading
          eyebrow="Service Area"
          title="Serving communities across Salt Lake County."
          description="If you are nearby and do not see your community listed, reach out and we will confirm whether service is available in your area."
        />
        <div className="service-area-list">
          {serviceAreas.map((area) => (
            <span key={area} className="service-area-pill">
              {area}
            </span>
          ))}
        </div>
      </div>
      <div className="service-area-image card">
        <img
          src={mountainImage}
          alt="Wasatch mountain view near the Salt Lake Valley"
          loading="lazy"
          decoding="async"
        />
      </div>
    </div>
  </section>
);

export default ServiceAreaSection;
